import Cookies from 'js-cookie';

export const TOKEN_KEY = "vnn-token";
export const isAuthenticated = () => {
  return Cookies.get(TOKEN_KEY) !== undefined};
export const getToken = () => Cookies.get(TOKEN_KEY);
export const login = token => {
  var in1H = 1/24;
  Cookies.set(TOKEN_KEY, token, { expires: in1H, secure: true });;
};

export const logout = () => {
  Cookies.remove(TOKEN_KEY, { path: '' });
};